import { useEffect, useRef, useState } from 'react';
import useQuery from '../../../util/useQuery';
import PreviewArticle from './components/PreviewArticle';
import PolicyService from '../../../services/Policy.service';
import { BackTop } from 'antd';
import { sendHeightToIframe } from '../sendHeight';
import GlobalService from '../../../services/Global.service';

export default function ViewFreeForm() {
    const params = useQuery();
    const id = params.get('id');
    const lang = params.get('lang');
    const [loading, setLoading] = useState(false);
    const [detail, setDetail] = useState();
    const ref = useRef();
    const [logo, setLogo] = useState('');
    const getImage = async (companyLogoId) => {
        try {
            const { data } = await GlobalService.getImageNoSecure(
                companyLogoId
            );
            if (data.resultData?.imageId) {
                setLogo(`data:image/png;base64,${data.resultData?.imageId}`);
            } else {
                setLogo('');
            }
        } catch (error) {
            console.log(error);
        }
    };
    useEffect(() => {
        setLoading(true);
        const getFreeForm = async () => {
            try {
                const { data } = await PolicyService.getFreeFormDetailPublic(
                    id
                );
                if (data?.resultData) {
                    const parse = JSON.parse(data?.resultData?.data);
                    setDetail(parse);
                    setLoading(false);
                    setLogo('');
                    if (parse?.freeFormPolicy?.freeFormCompanyLogoId) {
                        getImage(parse?.freeFormPolicy?.freeFormCompanyLogoId);
                    }
                    sendHeightToIframe(ref.current);
                } else {
                    setLoading(false);
                }
            } catch (error) {
                console.log(error);
                setLoading(false);
            }
        };
        if (id) getFreeForm();
        document.body.style.background = 'transparent';
    }, [id]);

    const SwitchLang = () => {
        const lang_ = lang.toLowerCase();
        return (
            <PreviewArticle
                lang={lang_}
                mode="view"
                detail={detail}
                loading={loading}
                logo={logo}
            />
        );
    };

    return (
        <div ref={ref}>
            <SwitchLang />
            <BackTop>
                <div
                    className="flex items-center justify-center !bg-[#1890ff]"
                    style={{
                        height: 40,
                        width: 40,
                        lineHeight: '40px',
                        borderRadius: 4,
                        backgroundColor: '#7B67FB',
                        color: '#fff',
                        textAlign: 'center',
                        fontSize: 14,
                    }}
                >
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M8.76395 15.232L8.76395 3.47773L14.8711 10.513C14.9695 10.6255 15.1523 10.5572 15.1523 10.4085L15.1523 8.63064C15.1523 8.55229 15.1242 8.47796 15.074 8.4197L8.48672 0.827956C8.42645 0.758424 8.35193 0.70266 8.26823 0.664442C8.18452 0.626224 8.09358 0.606445 8.00156 0.606445C7.90954 0.606445 7.8186 0.626224 7.7349 0.664442C7.65119 0.70266 7.57668 0.758424 7.51641 0.827956L0.888949 8.46389C0.862833 8.49403 0.848771 8.53019 0.848771 8.56836L0.848771 10.4065C0.848771 10.5552 1.03359 10.6235 1.13002 10.511L7.23716 3.47773L7.23716 15.232C7.23716 15.3204 7.30949 15.3927 7.39788 15.3927L8.60324 15.3927C8.69163 15.3927 8.76395 15.3204 8.76395 15.232Z"
                            fill="white"
                        />
                    </svg>
                </div>
            </BackTop>
        </div>
    );
}
